// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__32WuS","input":"styles_input__38ofM","checkTitle":"styles_checkTitle__1y8kW"};